module.exports = __webpack_public_path__ + "static/crj-zoom-474263624ad0a8593ff10c78752921e5.jpg";